import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BmsjHipsterSharedModule } from '../../../shared';
import { GermplasmAuditService } from '../germplasm-audit.service';
import { GermplasmAttributeAuditComponent, GermplasmAttributeAuditPopupComponent } from './germplasm-attribute-audit.component';
import { GERMPLASM_ATTRUBUTES_AUDIT_ROUTES } from './germplasm-attribute-audit.route';
import { GermplasmAttributeContext } from '../../../entities/germplasm/attribute/germplasm-attribute.context';
import { TruncateSpanComponent } from '../../../shared/util/span-truncate/truncate-span.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_ATTRUBUTES_AUDIT_ROUTES]),
        TruncateSpanComponent,
    ],
    declarations: [
        GermplasmAttributeAuditComponent,
        GermplasmAttributeAuditPopupComponent
    ],
    providers: [
        GermplasmAuditService,
        GermplasmAttributeContext
    ]
})
export class GermplasmAttributeAuditModule {
}
